import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useConfig() {
  return useQuery({
    queryKey: ["public-config"],
    queryFn: async () => (await api.get("/config")).data,
    staleTime: 30_000,
    retry: 4,
    retryDelay: (attempt) => Math.min(1500 * 2 ** attempt, 8000),
    refetchOnWindowFocus: true,
    placeholderData: (prev) => prev,
  });
}

export function useMetrics() {
  return useQuery({
    queryKey: ["public-metrics"],
    queryFn: async () => (await api.get("/metrics")).data,
    staleTime: 15_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    retry: 3,
    placeholderData: (prev) => prev,
  });
}

export const FALLBACK_CONFIG = {
  settings: {
    organizer_name: "SembangOhhyeahh",
    disclaimer_text:
      "Inisiatif bebas oleh SembangOhhyeahh. Bukan laman rasmi Pejabat Perdana Menteri atau Kerajaan Malaysia. Penggunaan nama PMX merujuk kepada tetamu sesi podcast.",
    public_gallery_enabled: false,
    public_voting_enabled: false,
    results_published: false,
    deadline_at: null,
    timezone: "Asia/Kuala_Lumpur",
  },
  submissions_open: true,
  phase: "submissions_open",
  meta: { categories: [], states: [], age_groups: [], area_types: [] },
};
